import {gsap} from "../../../../libs/gsap/all.js"
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {Howl} from "howler";

// Constructor
export class InteractiveButton extends PIXI.Container {

  constructor(callback, overridePivot, clickSound) {
    super();

    // this is use as a fix for buttons that were created early on in development.
    // Set this to false in your constructor if you do not want to override the pivot point when you press
    // Ignore otherwise
    this.overridePivot = typeof overridePivot !== 'undefined' ? overridePivot : true;
    // ==================================================================
    this.originalPosition = {x: 0, y: 0};
    this.originalPivot = {x: 0, y: 0};
    this.callback = callback;

    // Click sound
    if (clickSound) {
      this.clickSound = new Howl({
        src: [clickSound],
        loop: false,
        autoplay: false,
      });
    }

    this.enable();
  }

  enable() {
    this.eventMode = "static";
    this.removeAllEvents();

    this.on("pointerdown", this.onPress, this);
  }

  disable() {
    this.eventMode = "none";
    this.removeAllEvents();
  }

  onPress(e) {
    // We need to offset the container and changed the pivot point when pressing so we can scale from center
    if (this.overridePivot) {
      this.originalPosition = {x: this.position.x, y: this.position.y};
      this.originalPivot = {x: this.pivot.x, y: this.pivot.y};
      this.pivot.set(this.width / 2, this.height / 2)
      this.position.x += this.width / 2;
      this.position.y += this.height / 2;
    }

    gsap.to(this, {
      pixi: {
        scale: 0.95
      },
      duration: 0.15,
      overwrite: "auto"
    });

    if(this.clickSound) {
      this.clickSound.play();
    }

    this.off("pointerdown", this.onPress, this);
    this.on("pointerup", this.onRelease, this);
    this.on("pointerupoutside", this.onRelease, this);
  }

  // Animate back and execute action
  onRelease() {
    gsap.to(this, {
      pixi: {
        scale: 1
      },
      ease: "back.out(4)",
      duration: 0.15,
      overwrite: "auto",
      onComplete: () => {
        if (this.overridePivot) {
          this.position = {...this.originalPosition};
          this.pivot = {...this.originalPivot};
        }
        this.on("pointerdown", this.onPress, this);
      }
    });

    this.off("pointerup", this.onRelease, this);
    this.off("pointerupoutside", this.onRelease, this);

    this.callback();
  }

  removeAllEvents() {
    this.off("pointerdown", this.onPress, this);
    this.off("pointerup", this.onRelease, this);
    this.off("pointerupoutside", this.onRelease, this);
  }

}
